<template lang="">
    <div>
        <div class="userfix d-flex">
            <button class=" btn" @click.prevent="showUserInfoForm" title="基本資料">
                <img :src="base_url+'/files/images/databtn.png'">
            </button>
        </div>
        <modal ref="userInfoForm" name="基本資料">
            <template>
                <form>
                    <div class="form-group">
                        <label for="living">陽世</label>
                        <select2 id="living" class="form-control w-100 tags" multiple
                            placeholder="陽世姓名(可輸入多筆，每輸入一筆請按Enter)" v-model="information.陽世"></select2>
                    </div>
                    <div class="form-group">
                        <label for="schering">先靈</label>
                        <select2 id="schering" class="form-control w-100 tags" multiple
                            placeholder="先靈姓名(可輸入多筆，每輸入一筆請按Enter)" v-model="information.先靈"></select2>
                    </div>
                </form>
            </template>
            <template v-slot:footer>
                <div>
                    <button type="submit" class="btn btn-primary" @click.prevent="save">Save</button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
    import axios from 'axios';
    import jQuery from 'jquery';

    import ApiBase from './components/ApiBase';
    import eventHub from '../library/eventHub';

    export default {
        extends: ApiBase,
        data() {
            return {
                information: {
                    陽世: [],
                    先靈: []
                },
                base_url,
            }
        },
        mounted() {
            eventHub.$on('user-info:append', this.append);
            this.load();
        },
        methods: {
            append(data) {
                if (!data) return;
                if (data instanceof Array) data.forEach(item => this.append(item));
                if (typeof data === 'object') {
                    Object.keys(data).forEach(key => {
                        if (this.information.hasOwnProperty(key)) {
                            if (this.information[key] instanceof Array) {
                                if (!this.information[key].includes(data[key]))
                                    this.information[key].push(data[key]);
                                else return;
                            }
                            else this.information[key] = data[key];
                        } else {
                            this.$set(this.information, key, data[key]);
                        }
                    });
                } else {
                    return;
                }
                this.silenceSave();
            },
            showUserInfoForm() {
                this.dataIsLoading(true);
                this.load();
                this.$refs.userInfoForm.modalShow();
            },
            load() {
                axios.get(`${base_url}/api/info`)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        this.updateInformation(response_data);
                        this.dataIsLoading(false);
                    })
                    .catch((...response_error) => console.log(response_error));
            },
            silenceSave() {
                axios.post(`${base_url}/api/info`, this.information)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        this.updateInformation(response_data);
                    })
                    .catch((...response_error) => console.log(response_error));
            },
            save() {
                this.dataIsLoading(true);
                axios.post(`${base_url}/api/info`, this.information)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        this.updateInformation(response_data);
                        this.dataIsLoading(false);
                        this.$refs.userInfoForm.modalHide();
                    })
                    .catch((...response_error) => console.log(response_error));
            },
            updateInformation(data) {
                Object.keys(this.information).forEach(key => {
                    if (data[key]) {
                        this.information[key] = data[key];
                    }
                });
                eventHub.$data.userInfo = this.information;
                return;
            }
        }
    }
</script>
<style scoped>
    .userfix {
        position: fixed;
        right: -27px;
        margin: 1em;
        z-index: 1000;
        top: 105px;
    }

    .user-info-btn {
        border-color: #7a8473;
        color: #f9f9f9;
        border-radius: 50%;
        padding: 1.25em 1em;
        background-color: #7a8473;
    }

    .user-info-btn:hover {
        background-color: #f9f9f9;
        color: #7a8473;
    }
</style>